import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { FormattedMessage, useIntl } from 'react-intl';

import { Heading, Link } from '@printdeal/ui-library';

import { messages } from '../../../translations/quote';

import Head from '../../../../PrivateHead';
import Breadcrumb from '../../../../Breadcrumb';
import QuoteList from './QuoteList';
import CreateQuoteLink from './CreateQuoteLink';
import QuoteCreatedAlert from './QuoteCreatedAlert';

const QuoteListPage = () => {
  const intl = useIntl();

  return (
    <div className="data-sentry-block">
      <Head title={intl.formatMessage({
        id: messages.quoteTitle.id,
        defaultMessage: messages.quoteTitle.defaultMessage,
      })}
      />

      <div className="pd-mb-6 pd-flex pd-flex-col pd-gap-6">
        <Breadcrumb>
          <Breadcrumb.Item to="..">
            <FormattedMessage id="account.index.title" defaultMessage="My account" />
          </Breadcrumb.Item>
          <Breadcrumb.Item isCurrentPage>
            <FormattedMessage id="quotes.title" defaultMessage="My Quotes" />
          </Breadcrumb.Item>
        </Breadcrumb>

        <QuoteCreatedAlert />

        <div className="pd-flex pd-flex-col pd-gap-4 md:pd-flex-row">
          <Heading className="pd-grow">
            <FormattedMessage id="quotes.title" defaultMessage="My Quotes" />
          </Heading>
          <div className="pd-flex pd-shrink pd-items-center">
            <CreateQuoteLink />
          </div>
        </div>

        <QuoteList />

        <Link
          to="../"
          as={GatsbyLink}
          variant="secondary"
          iconBefore="chevron-left"
        >
          <FormattedMessage id="account.linkToAccount" defaultMessage="Link to account" />
        </Link>
      </div>
    </div>
  );
};

export default QuoteListPage;
